import React from 'react'
import { useDrag } from 'react-dnd'
import { Card, OrderDetails, OrderNumber } from '../../ProductionFlow/components-tests/ProductionOrderCard/style'

function ProductionOrderCard({ order }:any) {
    const [{ isDragging }, drag] = useDrag({
        type: 'PRODUCTION_ORDER',
        item: {
            id: order.id,
            day: order.day
        },
        collect: (monitor:any) => ({
            isDragging: !!monitor.isDragging()
        }),
    })

    return (
        <Card
            ref={drag}
        >
            <OrderNumber>PO-{order.id}</OrderNumber>
            <OrderDetails>
                <span>Order #{order.orderId}</span>
                <span>{order.status}</span>
            </OrderDetails>
        </Card>
    )
}

export default ProductionOrderCard